import useMediaQuery from "@mui/material/useMediaQuery";
import { Button, Layout } from "antd";
import React, { useLayoutEffect } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import MediaQuery from "react-responsive";
import { Link, useLocation, useNavigate } from "react-router-dom";

import Logo from "../../assets/images/logo.jpg";
// import sanadLogo from "../../assets/images/sanad-logo.svg";
// import notificationBill from "../../assets/images/notification-bill.svg";
import LanguageDropDown from "../../components/Common/LanguageDropDown";
import config from "../../config";
import { isArabic, showLangOptions } from "../../helpers/utils";
import {
  logout,
  setAuthInformation,
  updateApplicantInfo,
} from "../../redux/actions";
import { getApplicantInfo, getMyInfo, getUserContacts } from "../../services";
import ApplicationSidebar from "../sidebar";
import HeaderWrapper from "./style";

// import i18n from "../../i18n";

const { Header } = Layout;

const ApplicationHeader = () => {
  const userInfo = useSelector((state) => state.userInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const matches = useMediaQuery(
    `(min-width:${config.breakdowns.DESKTOP_MIN_WIDTH}px)`
  );
  const matchesLg = useMediaQuery(`(max-width:1024px)`);

  const navigationItems = [
    {
      key: "citizn",
      label: t("header.citizinPage"),
      url: "/home",
    },
    {
      key: "gob",
      label: t("header.govServices"),
      url: "/government-services",
    },
    {
      key: "nearest",
      label: t("header.myNearest"),
      url: "/my-applications",
    },
  ];

  const navigateItem = (url) => {
    navigate(url, { replace: true });
  };

  const iaActive = (url) => {
    return location.pathname.indexOf(url) !== -1;
  };

  const getName = () => {
    const name = isArabic()
      ? userInfo.arabicShortName
      : userInfo.englishShortName;
    return name;
  };

  // useLayoutEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       if (localStorage.getItem("accessToken")) {
  //         const [myInfo, userContacts, applicantInfo] = await Promise.allSettled([
  //           getMyInfo(),
  //           getUserContacts(),
  //           getApplicantInfo(),
  //         ]);

  //         const {
  //           anamE1,
  //           anamE2,
  //           anamE3,
  //           anamE4,
  //           enamE1,
  //           enamE2,
  //           enamE3,
  //           enamE4,
  //           bgovR_C,
  //           naT_NO,
  //           birthdt,
  //           carD_NO,
  //           nationality,
  //         } = myInfo.data;

  //         const arabicName = `${anamE1} ${anamE2} ${anamE3} ${anamE4}`;
  //         const englishName = `${enamE1} ${enamE2} ${enamE3} ${enamE4}`;

  //         dispatch(
  //           setAuthInformation({
  //             ...userInfo,
  //             birthPlace: bgovR_C?.citY_D,
  //             nationalId: naT_NO,
  //             englishName,
  //             arabicName,
  //             birthDate: birthdt,
  //             carD_NO,
  //             nationality: nationality,
  //             email: userContacts.data.email || "",
  //             phone: userContacts.data.phone || "",
  //           })
  //         );

  //         dispatch(updateApplicantInfo(applicantInfo.data));
  //       }
  //     } catch (error) {
  //       // Handle errors here, for example, show an error message or log the error
  //       console.error("Error occurred:", error);
  //     }
  //   };

  //   fetchData();
  // }, []);
  useLayoutEffect(() => {
    const fetchData = async () => {
      try {
        if (localStorage.getItem("accessToken")) {
          const promises = [getMyInfo(), getUserContacts(), getApplicantInfo()];

          const results = await Promise.allSettled(promises);

          const [myInfoResult, userContactsResult, applicantInfoResult] =
            results;

          let tempUserInfo = {};
          if (myInfoResult.status === "fulfilled") {
            const myInfo = myInfoResult.value.data;
            const {
              anamE1,
              anamE2,
              anamE3,
              anamE4,
              enamE1,
              enamE2,
              enamE3,
              enamE4,
              bgovR_C,
              naT_NO,
              birthdt,
              carD_NO,
              nationality,
            } = myInfo;

            const arabicName = `${anamE1} ${anamE2} ${anamE3} ${anamE4}`;
            const englishName = `${enamE1} ${enamE2} ${enamE3} ${enamE4}`;

            tempUserInfo = {
              ...userInfo,
              birthPlace: bgovR_C?.citY_D,
              nationalId: naT_NO,
              englishName,
              arabicName,
              birthDate: birthdt,
              carD_NO,
              nationality: nationality,
              email:
                userContactsResult.status === "fulfilled"
                  ? userContactsResult.value.data.email || ""
                  : "",
              phone:
                userContactsResult.status === "fulfilled"
                  ? userContactsResult.value.data.phone || ""
                  : "",
            };
            dispatch(setAuthInformation(tempUserInfo));
          }

          if (applicantInfoResult.status === "fulfilled") {
            dispatch(updateApplicantInfo(applicantInfoResult.value.data));
            const userData = applicantInfoResult.value.data;
            if (userData.companyInformation) {
              dispatch(
                setAuthInformation({
                  ...userInfo,
                  nationalId: userData.companyInformation.compid,
                  arabicName: userData.companyInformation.companame,
                  email:
                    userContactsResult.status === "fulfilled"
                      ? userContactsResult.value.data.email || ""
                      : "",
                  phone:
                    userContactsResult.status === "fulfilled"
                      ? userContactsResult.value.data.phone || ""
                      : "",
                })
              );
            }
            if (userData.citizenInformation) {
              dispatch(
                setAuthInformation({
                  ...tempUserInfo,
                  nationalId: userData.citizenInformation.naT_NO,
                  arabicName: `${userData.citizenInformation.anamE1} ${userData.citizenInformation.anamE2} ${userData.citizenInformation.anamE3} ${userData.citizenInformation.anamE4}`,
                  email:
                    userContactsResult.status === "fulfilled"
                      ? userContactsResult.value.data.email || ""
                      : "",
                  phone:
                    userContactsResult.status === "fulfilled"
                      ? userContactsResult.value.data.phone || ""
                      : "",
                })
              );
            }

            if (userData.foreignInformation) {
              dispatch(
                setAuthInformation({
                  ...userInfo,
                  // nationalId: userData.foreignInformation.naT_NO,
                  arabicName: userData.foreignInformation.full_name,
                  email:
                    userContactsResult.status === "fulfilled"
                      ? userContactsResult.value.data.email || ""
                      : "",
                  phone:
                    userContactsResult.status === "fulfilled"
                      ? userContactsResult.value.data.phone || ""
                      : "",
                })
              );
            }
          }
        }
      } catch (error) {
        // Handle errors here, for example, show an error message or log the error
        console.error("Error occurred:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location]);

  return (
    <HeaderWrapper>
      <Header
        className={`site-layout-background d-flex justify-content-between header-container ${
          matches ? "" : " px-1 px-sm-3"
        } ${matchesLg && "p-0"}`}
      >
        <MediaQuery minWidth={config.breakdowns.DESKTOP_MIN_WIDTH}>
          <div className="d-flex align-items-center justify-content-center col-3">
            <img
              onClick={() => navigateItem("/")}
              src={Logo}
              width="150"
              className="cursor-pointer"
              alt="logo"
            />
            {/* <img src={sanadLogo} className="mx-2" width="80" alt="logo" /> */}
          </div>
        </MediaQuery>

        {matches ? (
          <div className="d-flex align-items-center flex-column text-white col-6 ">
            <h6 className="mb-3 mt-4 text-white fm-kufi-regular ">
              {t("header.welcomeToSanad")}
            </h6>
            {matches ? (
              <MediaQuery minWidth={config.breakdowns.DESKTOP_MIN_WIDTH}>
                <ul className=" list-items d-flex justift-content-between p-0 list-unstyled">
                  {navigationItems.map((item) => (
                    <li
                      key={item.key}
                      onClick={() => navigateItem(item.url)}
                      className={
                        "mx-2 fm-kufi-regular " +
                        (iaActive(item.url) ? " active" : "")
                      }
                    >
                      {item.label}
                    </li>
                  ))}
                </ul>
              </MediaQuery>
            ) : (
              <div></div>
            )}
          </div>
        ) : (
          <div className="mt-10 align-items-center mb-2 mt-3">
            <img
              onClick={() => navigateItem("/")}
              src={Logo}
              width="150"
              alt="logo"
            />
            {/* <img src={sanadLogo} className="mx-2" width="80" alt="logo" /> */}
          </div>
        )}

        {matches ? (
          <MediaQuery minWidth={config.breakdowns.DESKTOP_MIN_WIDTH}>
            <div className="d-flex flex-column gap-3 justify-content-center">
              <div className="d-flex justify-content-end align-items-center col-3 w-100">
                {/* <img width={"18"} src={notificationBill} alt="notificationBill" /> */}
                {/* <MediaQuery minWidth={1024}> */}
                <h6 className="text-white text-center mb-0 fm-kufi-regular mx-2">
                  {getName()}
                </h6>

                {/* </MediaQuery> */}

                {showLangOptions() && <LanguageDropDown />}

                <Button
                  onClick={() => dispatch(logout())}
                  className="logout-btn fm-kufi-regular"
                >
                  {t("header.logout")}
                </Button>
              </div>
              <div className="w-100 d-block">
                <Link
                  to="/profile"
                  className="text-white d-block text-center mb-0 fm-kufi-regular position-relative"
                  style={{
                    textDecoration: "underline",
                    color: "white",
                    fontSize: "14px",
                  }}
                >
                  {t("header.profile")}
                </Link>
                {/* <a
                  href={`${
                    config.changePasswordLink
                  }?token=${localStorage.getItem("token")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white d-block text-center mb-0 fm-kufi-regular position-relative"
                  style={{
                    textDecoration: "underline",
                    color: "white",
                    fontSize: "14px",
                  }}
                >
                  {t("header.changePassword")}
                </a> */}
              </div>
            </div>
          </MediaQuery>
        ) : (
          <div className="d-flex justify-content-center align-items-center gap-2 gap-sm-3">
            <div>
              {/* <img
                width={"16"}
                src={notificationBill}
                className="mb-2"
                alt="notificationBill"
              /> */}
            </div>
            <ApplicationSidebar />
          </div>
        )}
      </Header>
    </HeaderWrapper>
  );
};
export default ApplicationHeader;
